import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import "./Start.css";

export default function Start() {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is logged in
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    if (!isLoggedIn) {
      navigate("/login");
    }
  }, [navigate]);

  const handleEnter = () => {
    navigate("/");
  };

  return (
    <div className="start-page">
      <div className="start-content">
        <img src="/Hi.png" alt="Hi" className="start-hi" />
        <div className="start-welcome">
          <h2>WELCOME TO iGAMESTECH</h2>
          <p>
            iGamesTech is mobile app and game development company that offers development and publishing solutions from concept, development to app discovery. We have worked on diverse projects with a global customer base. As a leading mobile app development company, iGames Tech specializes in crafting cutting-edge mobile and web applications that revolutionize the way businesses engage with their customers.
          </p>
        </div>
        <button onClick={handleEnter} className="btn-enter">
          ENTER iGAMESTECH
        </button>
      </div>
    </div>
  );
}
